import { Accordion, AccordionHeader, AccordionItem, AccordionPanel } from '@fluentui/react-components';
import { format, parseISO } from 'date-fns';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { SentEmail } from '../../../models';
import './SentEmailsTable.scss';
import { FlexBox } from '../../shared-components/flex-box';

const SentEmailsTableImpl: React.FC = () => {
  const {
    emailPageUiStore,
  } = useStores();

  const renderRecipients = (sentEmail: SentEmail): string => {
    return [
      ...(sentEmail.targetGroups.map((group) => group.displayName) || []),
      ...(sentEmail.individualRecipients || [])
    ].join(', ');
  };

  return (
    <div
      className='sent-email-table'
    >
      <div className='sent-email-table__grid'>
        <span>Email title</span>
        <span>Date / time sent</span>
        <span>Sent by</span>
        <span>Recipients</span>
        <span />
      </div>

      <Accordion collapsible>
        {
          emailPageUiStore.sentEmails.length ? emailPageUiStore.sentEmails.map((sentEmail, key) => (
            <AccordionItem
              key={`semt-email-${key}`}
              value={`semt-email-${key}`}
            >
              <AccordionHeader
                expandIconPosition='end'
                button={{
                  className: 'accordion-button',
                }}
              >
                <b>{sentEmail.title}</b>
                <span>{sentEmail.sentOnDateTime ? format(parseISO(sentEmail.sentOnDateTime), 'MM/dd/yyyy @ h:mm aaa') : ''}</span>
                <span>{sentEmail.sentBy}</span>
                <span>{renderRecipients(sentEmail)}</span>
              </AccordionHeader>
              <AccordionPanel
                className='sent-email-table__grid'
              >
                <>
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </>
              </AccordionPanel>
            </AccordionItem>
          )) : (
            <FlexBox
              isFullWidth
              content='center'
              aligns='center'
              className='row-empty'
            >
              Sorry, currently there is no email.
            </FlexBox>
          )
        }
      </Accordion>
    </div>
  );
}

export const SentEmailsTable = observer(SentEmailsTableImpl);
